export default "__VITE_PUBLIC_ASSET__1b3d49b4__"